import { FC } from "react";
import { IconProps } from "./types";

export const CaretLeftLine: FC<IconProps> = ({
  fill = "currentColor",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.14 4.37a1.203 1.203 0 0 0-1.735 0l-6.546 6.737a1.29 1.29 0 0 0 0 1.786l6.546 6.737c.48.493 1.256.493 1.736 0a1.29 1.29 0 0 0 0-1.786L10.462 12l5.678-5.844a1.29 1.29 0 0 0 0-1.786z"
      fill={fill}
    />
  </svg>
);
